// formkit.config.js
import { generateClasses } from '@formkit/themes';
import { genesisIcons } from '@formkit/icons';
import myTheme from './form-theme'; // change to your theme's path
import { defineFormKitConfig } from '@formkit/vue';
import { de, fr } from '@formkit/i18n';

export default defineFormKitConfig({
  // Validation messages, the active one is set by plugins/formkit-locale.ts
  locales: { de, fr },
  locale: 'de',
  icons: {
    ...genesisIcons
  },
  config: {
    classes: generateClasses(myTheme)
  }
});
